import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sun, Moon, Menu, X } from 'lucide-react';
import './Header.css';

const Header = ({ isLightMode, setIsLightMode }) => {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['core-modules', 'featured-module', 'analytics-module'];
      const scrollPosition = window.scrollY + 100; // offset for header

      let current = '';
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element && element.offsetTop <= scrollPosition) {
          current = section;
        }
      }

      setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu on scroll
  useEffect(() => {
    if (isMenuOpen) setIsMenuOpen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSection]);

  const isActive = (path, hash = '') => {
    if (hash) {
      return activeSection === hash;
    }
    return location.pathname === path && !activeSection;
  };

  return (
    <header className="header glass-panel">
      <div className="container header-content">
        <Link to="/" className="logo" onClick={(e) => {
          if (location.pathname === '/') {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
            if (window.location.hash) {
              window.history.pushState(null, '', '/');
            }
          }
          setIsMenuOpen(false);
        }}>
          <span className="logo-mark">X</span>
          <span className="logo-wordmark">
            <span className="logo-name">X-Max</span>
            <span className="logo-tagline">Manufacturing Excellence Reimagined</span>

          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className={`nav-links ${isMenuOpen ? 'nav-open' : ''}`}>
          <Link
            to="/"
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
            onClick={(e) => {
              setIsMenuOpen(false);
              if (location.pathname === '/') {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
                window.history.pushState(null, '', '/#/');
              }
            }}
          >Home</Link>

          <Link
            to="/#core-modules"
            className={`nav-link ${isActive('/', 'core-modules') ? 'active' : ''}`}
            onClick={(e) => {
              setIsMenuOpen(false);
              if (location.pathname === '/') {
                e.preventDefault();
                document.querySelector('#core-modules')?.scrollIntoView({ behavior: 'smooth' });
                window.history.pushState(null, '', '/#/core-modules');
              }
            }}
          >Core Modules</Link>

          <Link
            to="/#featured-module"
            className={`nav-link ${isActive('/', 'featured-module') ? 'active' : ''}`}
            onClick={(e) => {
              setIsMenuOpen(false);
              if (location.pathname === '/') {
                e.preventDefault();
                document.querySelector('#featured-module')?.scrollIntoView({ behavior: 'smooth' });
                window.history.pushState(null, '', '/#/featured-module');
              }
            }}
          >Featured Module</Link>

          <Link
            to="/#analytics-module"
            className={`nav-link ${isActive('/', 'analytics-module') ? 'active' : ''}`}
            onClick={(e) => {
              setIsMenuOpen(false);
              if (location.pathname === '/') {
                e.preventDefault();
                document.querySelector('#analytics-module')?.scrollIntoView({ behavior: 'smooth' });
                window.history.pushState(null, '', '/#/analytics-module');
              }
            }}
          >Loss Analysis</Link>

          <Link
            to="/about"
            className={`nav-link ${isActive('/about') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >About Us</Link>
        </nav>

        <div className="header-actions">
          <button
            onClick={() => setIsLightMode(!isLightMode)}
            className="theme-toggle"
            aria-label="Toggle theme"
          >

            {isLightMode ? <Moon size={20} /> : <Sun size={20} />}
          </button>
          {/* <Link to="/login" className="nav-link" style={{ marginRight: '1rem' }}>Login</Link> */}
          <Link to="/book-now" className="btn btn-primary btn-book-demo">Book Demo</Link>
          {/* Hamburger Button */}
          <button
            className="hamburger"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
